export { Root as SubTitle } from './SubTitle.styles'
